<template>
    <chart-card>
        <template slot="header">
            <h4 class="card-title">Vendas por Cidade</h4>
            <p class="card-category">Vendas por região no periodo</p>
        </template>
        <template slot="footer">
            <hr>
            <div class="stats">
                <i class="fa fa-clock-o"></i> Ultima atualização: {{lastUpdatedFormated}}
            </div>
        </template>
        <div>
            <table class="table table-hover table-striped" style="margin-bottom: 0">
                <thead>
                <tr>
                    <th width="60%">Bairro</th>
                    <th class="text-center">Quantidade</th>
                </tr>
                </thead>
            </table>
        </div>
        <div id="chart" class="table-responsive" style="height: 370px; overflow-y: scroll;">
            <table class="table table-hover table-striped" >
                <tbody>
                <tr :key="item.name" v-for="item in tableData" >
                    <td style="width: 60%">{{item.name}}</td>
                    <td style="width:40%;align: center" class="text-center">{{item.cases}}</td>
                </tr>
                </tbody>
            </table>
        </div>
    </chart-card>
</template>

<script>
    import ChartCard from "@/components/ChartCard";
    import moment from "moment";
    export default {
        name: "ListByRegion",
        components: {ChartCard},
        props:['tableData', 'lastUpdated'],
        computed: {
            lastUpdatedFormated (){
                return moment(this.lastUpdated, 'YYYY-MM-DD').format('DD/MM/YYYY [às] HH:mm:ss')
            }
        }
    }
</script>

<style scoped>

</style>
